/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/link/css/link';
import '@swisslife/patterns-base/src/atoms/loader/css/loader';
import '../../../molecules/segment-teaser/css/segment-teaser';
import './main-navigation.scss';
import './main-navigation-link-top-level.scss';
import './main-navigation-link-sub.scss';
import './main-navigation-link-upper-level.scss';
import './main-navigation-link-back.scss';
